import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

const path = 'rooms/:roomId/publish' as const;

export function usePublishOldRoom() {
  return useMutation({
    mutationFn: async (roomId: string) =>
      apiMutation('PATCH', {
        path,
        params: { roomId },
      }) as Promise<void>,
    onSuccess: (_, roomId) => {
      message.success(`Room #${roomId} status updated`);
    },
    onError: () => {
      message.error('Error while modifying room status');
    },
  });
}
